import {
  createPrintError,
  PRINT_ERROR_CODES,
} from "../contracts";

export async function printCloudPrntAdapter({ job }) {
  throw createPrintError(
    PRINT_ERROR_CODES.ADAPTER_UNAVAILABLE,
    "CloudPRNT Adapter belum diaktifkan.",
    {
      job,
      adapter: "cloudprnt",
    }
  );
}
